const {
  fleet,
  iam,
  driver,
  auditLog,
  business,
  passenger,
  customer,
  internal,
  phoenix,
  marketing,
  BookingCommandConnector,
  BookingHistoryServiceConnector,
  BookingEtaConnector,
  BookingQueryConnector,
  Ic2BookingServiceConnector,
  OfferServiceConnector,
  PaymentMethodCommandConnector,
  FareEstimatorConnector,
  RatingCommandConnector,
  RatingQueryConnector,
  ReceiptServiceConnector,
  ReverseGeocoderServiceConnector,
  SuggestionServiceConnector,
  UserServiceConnector,
} = require('./src');

module.exports = {
  fleet,
  iam,
  driver,
  auditLog,
  business,
  passenger,
  customer,
  internal,
  phoenix,
  marketing,
  BookingCommandClient: BookingCommandConnector,
  BookingHistoryServiceClient: BookingHistoryServiceConnector,
  BookingEtaClient: BookingEtaConnector,
  BookingQueryClient: BookingQueryConnector,
  Ic2BookingServiceClient: Ic2BookingServiceConnector,
  OfferServiceClient: OfferServiceConnector,
  PaymentMethodCommandClient: PaymentMethodCommandConnector,
  FareEstimatorClient: FareEstimatorConnector,
  RatingCommandClient: RatingCommandConnector,
  RatingQueryClient: RatingQueryConnector,
  ReceiptServiceClient: ReceiptServiceConnector,
  ReverseGeocoderServiceClient: ReverseGeocoderServiceConnector,
  SuggestionServiceClient: SuggestionServiceConnector,
  UserServiceClient: UserServiceConnector,
};
